import {
  createReactPermissionBindings,
  PermissionsNeededByProvider
} from 'packages/permissions/react';

export const {
  usePermissions,
  Permissions,
  PermissionGroup,
  PermissionMatch,
  PermissionProvider
} = createReactPermissionBindings({
  // A mapping of permission names to API features.
  // This is the typing definitions too.

  isTalkdeskEnabled: 'webapi:talkdesk_chatbot_feature_enabled'
});

export type PermissionNames = PermissionsNeededByProvider<
  typeof PermissionProvider
>;
